import React from 'react'
import { Button, ButtonProps } from './Button'

export const ButtonSecondary: React.SFC<ButtonProps> = props => (
  <Button type="secondary" {...props} />
)
